import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmdialogComponent, ConfirmDialogModel } from '@app/components/shared/dialog/confirmdialog/confirmdialog.component';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-causes',
  templateUrl: './admin-causes.component.html',
  styleUrls: ['./admin-causes.component.css']
})
export class AdminCausesComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  causes: any[] = [];
  cols: any[];
  formdata;
  display = false;
  displayaddcause = false;
  subscriptions: Subscription[] = [];
  result = '';
  value: any;

  constructor(
    private adminService: AdminService,
    private messageService: MessageService,
    public dialog: MatDialog,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.cols = [
      { field: 'name', header: 'Namn' },
      { field: 'description', header: 'Beskrivning' }
    ];
    this.getCauses();
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  getCauses() {
    this.adminService.GetCauses().subscribe(data => {
      if (data) {
        this.causes = data;
      }
    });
  }

  saveCause(evt) {
    this.adminService.UpdateCause(evt).subscribe(x => {
      this.display = false;
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Orsak uppdaterad.' });
      this.getCauses();
    });
  }

  saveAddCause(evt) {
    this.adminService.AddCause(evt).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Orsak tillagd.' });
        this.getCauses();
        this.displayaddcause = false;
      }
    });
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du radera vald orsak?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteCause(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteCause(rowdata) {
    this.adminService.RemoveCause(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Orsak raderad.' });
        this.getCauses();
      }
    });
  }

  cancelEdit() {
    this.display = false;
  }

  cancelAdd() {
    this.displayaddcause = false;
  }
  addCause() {
    this.displayaddcause = true;
  }

  exportToCSV() {
    let firstrow = '';
    // tslint:disable-next-line:max-line-length
    this.cols.forEach(c => {
      firstrow += c.header + ';';
    });
    const filnamn = 'OF_causes';
    const excelrecords: any[] = [];
    this.causes.forEach(r => {
      const row = {
        name: r.name,
        description: r.description
      }
      excelrecords.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    })
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }
}
